import * as React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Button, Icon, Sheet, Text } from '@amzn/storm-ui';
import { useIsRTL } from 'src/commons/hooks';
import { MobileNavSheet } from '../nav/components/MobileSideNav/MobileNavSheet';
import { IA2MobileAccountDropdown } from './components/AccountDropdown/IA2MobileAccountDropdown';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';

type MobileAccountSwitcherOverlay = {
  isOpen: boolean;
  handleClose: () => void;
};

export const MobileAccountSwitcherCloseBtnContainer = styled.div`
  background-color: ${({ theme }) => theme.color.gray[75]};
  padding: ${({ theme }) => theme.spacing.xxsmall.default} 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[400]};
`;

export const MobileAccountSwitcherCloseBtnText = styled.strong`
  padding-left: ${({ theme }) => theme.spacing.xsmall.default};
`;

export const MobileAccountSwitcherIcon = styled(Icon)`
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const SecondaryMobileMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const AllAccountsContainer = styled.div`
  text-align: center;
`;

export const MobileAccountSwitcherOverlay: React.FC<
  MobileAccountSwitcherOverlay
> = ({ isOpen, handleClose }) => {
  const isRtl = useIsRTL();
  const bundle = useAccountDropdownBundle();
  const chromeConfig = useChromeConfigContext();
  const isAllAccountsPageScope =
    chromeConfig.pageHeader?.pageScope === 'ALL_ACCOUNTS';

  return (
    <ThemeProvider
      theme={(theme) => ({
        ...theme,
        modal: {
          ...theme.modal,
          zIndex: 799,
        },
      })}
    >
      {isAllAccountsPageScope && (
        <Sheet
          isOpen={isOpen}
          onClose={handleClose}
          closeButton={{
            type: 'icon',
            label: 'close',
          }}
          side="bottom"
          sheetElementId="AACChromePortal"
        >
          <AllAccountsContainer>
            <Text>{bundle.getMessage('global-accounts-pill-message')}</Text>
          </AllAccountsContainer>
        </Sheet>
      )}
      {!isAllAccountsPageScope && (
        <MobileNavSheet
          isOpen={isOpen}
          onClose={handleClose}
          closeButton={{
            type: 'icon',
            label: 'close',
          }}
          type="light"
          side="start"
          withCloseButton={false}
          hasInnerPadding={false}
          sheetElementId="AACChromePortal"
        >
          <SecondaryMobileMenuContainer>
            <MobileAccountSwitcherCloseBtnContainer>
              <Button
                onClick={handleClose}
                variant="transparent"
                role="button"
                data-ccx-e2e-id="aac-mobile-account-switcher-done-button"
              >
                <MobileAccountSwitcherIcon
                  type={`angle-${isRtl ? 'right' : 'left'}`}
                />
                <MobileAccountSwitcherCloseBtnText>
                  {bundle.getMessage('account-switcher-done-label')}
                </MobileAccountSwitcherCloseBtnText>
              </Button>
            </MobileAccountSwitcherCloseBtnContainer>
            <IA2MobileAccountDropdown />
          </SecondaryMobileMenuContainer>
        </MobileNavSheet>
      )}
    </ThemeProvider>
  );
};
